import * as yup from 'yup';

const FormSchemas = {
    nameReview: yup.object().shape({
        legalFirstName: yup.string().required("Legal First Name must have a value."),
        legalLastName: yup.string().required('Legal Last Name must have a value.')
    }),
    addressReview: yup.object().shape({}),

};

export default FormSchemas;